import { jsx as _jsx } from "react/jsx-runtime";
import React, { Fragment } from 'react';
import styles from './tabs.module.css';
const ViewTransition = React.ViewTransition;
// ViewTransition is currently a React canary API and may be missing from stable type exports.
// We use it when present at runtime, and fall back to Fragment to keep this component TS-safe in all packages.
const ViewTransitionOrFragment = ({ children, ...props })=>{
    if (!ViewTransition) {
        return /*#__PURE__*/ _jsx(Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ _jsx(ViewTransition, {
        ...props,
        children: children
    });
};
export const AnimatedBackground = ({ id })=>/*#__PURE__*/ _jsx(ViewTransitionOrFragment, {
        name: id,
        share: styles['active-bg'],
        children: /*#__PURE__*/ _jsx("div", {
            className: styles['active-tab-background']
        })
    });

//# sourceMappingURL=animated-background.js.map